import React from 'react';
import { Card, Box, Typography, Chip, IconButton, ModalClose } from '@mui/joy';
import {
  SentimentSatisfied, SentimentDissatisfied, Visibility, Chat, FormatQuote,
  CallToAction, Score, Tag, AutoAwesome, ReadMore, EmojiEvents, PeopleAlt,
  TrendingUp, TrendingDown, FormatBold as FormatBoldIcon,
} from '@mui/icons-material';

import SentimentNeutralOutlinedIcon from '@mui/icons-material/SentimentNeutralOutlined';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';


const getScoreColor = (score) => {
  if (score >= 7) return '#e6ffe6';
  if (score >= 4) return '#fff6e6';
  return '#ffe6e6';
};

const ScoreIndicator = ({ icon, label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginY: '0px' }}>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {icon}
      <Typography level="title-xs" sx={{ marginLeft: '0.5rem' }}>{label}</Typography>
    </Box>
    <Typography
      level="body-xs"
      sx={{
        backgroundColor: getScoreColor(value),
        border: '1px solid #c6c3c3',
        borderRadius: '50%',
        padding: '5px',
        width: '40px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {value}
    </Typography>
  </Box>
);

/* return overall score if poor add poor face icon, a face aswell for fair, good and excellent*/
const overallScore = (score) => {
  switch (score) {
    case 'poor': return <IconButton sx={{ gap: 1 }}><SentimentDissatisfied sx={{ color: 'red' }} /> Poor</IconButton>
    case 'fair': return <IconButton sx={{ gap: 1 }}><SentimentNeutralOutlinedIcon sx={{ color: 'orange' }} /> Fair</IconButton>
    case 'good': return <IconButton sx={{ gap: 1 }}><SentimentSatisfiedAltOutlinedIcon sx={{ color: 'green' }} /> Good</IconButton>
    case 'excellent': return <IconButton sx={{ gap: 1 }}><SentimentVerySatisfiedOutlinedIcon sx={{ color: 'green' }} /> Excellent</IconButton>
    default: return <IconButton sx={{ gap: 1 }}><SentimentSatisfied sx={{ color: 'green' }} /> Good</IconButton>
  }
}

const PostStrength = ({ postStrength, setShowPostStrength }) => {

  return (
    <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
      {postStrength && postStrength.engagement_score && (
        <Box sx={{ paddingRight: '0.5rem' }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography level="title-xs">Post Strength</Typography>
            <IconButton>
              <CloseOutlinedIcon onClick={() => setShowPostStrength(false)} />
            </IconButton>
          </Box>

          <Typography level="body-xs">

            {overallScore(postStrength.sentiment)}

          </Typography>

          <Card sx={{ width: '100%', marginTop: '0.5rem' }}>
            <ScoreIndicator icon={<EmojiEvents sx={{ color: '#FFD700' }} />} label="Engagement Score" value={postStrength.engagement_score} />
            <ScoreIndicator icon={<ReadMore />} label="Readability" value={postStrength.readability} />
            <ScoreIndicator icon={<SentimentSatisfied />} label="Emotional Appeal" value={postStrength.emotional_appeal} />
            <ScoreIndicator icon={<FormatBoldIcon />} label="Boldness" value={postStrength.boldness} />
            <ScoreIndicator icon={<Visibility />} label="Relevance" value={postStrength.relevance} />
            <ScoreIndicator icon={<PeopleAlt />} label="Audience Targeting" value={postStrength.audience_targeting} />
          </Card>

          <Card sx={{ width: '100%', marginTop: '0.5rem', p: 1.5 }}>
            <Typography level="title-xs">Hook Suggestion</Typography>
            <Typography level="body-xs">{postStrength.hook}</Typography>
          </Card>

          <Card sx={{ width: '100%', marginTop: '0.5rem', p: 1.5 }}>
            <Typography level="title-xs">Call To Action Suggestion</Typography>
            <Typography level="body-xs">{postStrength.cta}</Typography>
          </Card>

          <Card sx={{ width: '100%', marginTop: '0.5rem', p: 1.5 }}>
            <Typography level="title-xs">Engagement Strategy</Typography>
            <Typography level="body-xs">{postStrength.engagement_strategy}</Typography>
          </Card>

          <Card sx={{ width: '100%', marginTop: '0.5rem', p: 1.5 }}>
            <Typography level="title-xs">Hashtags Suggestions</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '0rem' }}>
            <Typography level="body-xs"> {postStrength?.hashtags}</Typography>
            </Box>
          </Card>

          <Card sx={{ width: '100%', marginTop: '0.5rem', p: 1.5 }}>
            <Typography level="title-xs">Post Strength</Typography>
            <Typography level="body-xs">{postStrength.post_strength}</Typography>
          </Card>

          <Card sx={{ width: '100%', marginTop: '0.5rem', p: 1.5 }}>
            <Typography level="title-xs">Personalization</Typography>
            <Typography level="body-xs">{postStrength.personalization}</Typography>
          </Card>

          <Card sx={{ width: '100%', marginTop: '0.5rem', p: 1.5 }}>
            <Typography level="title-xs">Length and Formatting</Typography>
            <Typography level="body-xs">{postStrength.length_and_formatting}</Typography>
          </Card>
        </Box>
      )}

    </div>
  );
}

export default PostStrength;
